import React, { useState, useEffect, useRef } from "react";
import QRCodeStyling from "qr-code-styling";

interface Props {
  url: string;
  size?: number;
  containerClassName?: string;
}

const QrCode = ({ url, size, containerClassName }: Props) => {
  const ref = useRef(null);
  const [qrCode, setQrCode] = useState<any>(null);

  useEffect(() => {
    if (!qrCode) {
      return;
    }
    qrCode.append(ref.current);
  }, [qrCode]);
  useEffect(() => {
    setQrCode(
      new QRCodeStyling({
        data: url,
        qrOptions: {
          typeNumber: 0,
          mode: "Byte",
          errorCorrectionLevel: "L",
        },
        width: size,
        height: size,
        dotsOptions: {
          color: "#000000",
          type: "rounded",
        },
        cornersSquareOptions: {
          type: "extra-rounded",
        },
      }),
    );
  }, [url, size]);

  return (
    <div ref={ref} className={containerClassName ? containerClassName : ""} />
  );
};

export default QrCode;
